// manifest
import '@lottiefiles/lottie-player';
import 'pwacompat/src/pwacompat';

// add better focus and input type detection on body element (for development)
// import 'what-input';

// components
import './components/aucorNavigation';
import './components/bootstrap';
import './components/footer';
import './components/navigation';
import './components/header';
import './components/tabs';
import './components/maps';
import './components/coworkerArchive';
import './components/phaseModule';
import './components/globalAllocation';
import './components/postArchiveGrid';
import './components/lottieInteractivity';
import './components/swiper';
import './components/modal';
import './components/strategyPortfolios';
import './components/investmentProfile';
import './components/investmentProcess';
import './components/formSelectionButton';
import './components/listFieldPlaceholders';

// infinte scroll for facetwp
// import './components/lazyLoading';
